module.exports = __webpack_public_path__ + "img/jicai.001b6492.png";